import { Component, ViewContainerRef, OnInit, ViewChild, TemplateRef} from '@angular/core';

//Este componente serve apenas para reutilizar a template de forma facila
//Facilitando a inclusão de valores "Default" para todas as dropdowns
//Caso usar isto como um componente transversalmente como componente cause um overhead desnecessário
//Poderá ser refeito de outra forma

//Adicionalmente isto renderiza o html de forma estranha uma vez que injeta o
//template após o wrapper do componente

@Component({
    selector: 'default-dropdown-values',
  template: `<ng-template #template><option  [value]="undefined">{{'Generic.DropdownPlaceholder' | translate}}</option></ng-template>`,
    standalone: false
})
export class DefaultDropdownValueComponent implements OnInit {
  @ViewChild('template', { static: true, read: TemplateRef }) template;
  constructor(private viewContainerRef: ViewContainerRef) { }
  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }
}
